import React from 'react';
import { SectionTitle, SectionTitleProps } from '@noths/polaris-client-ribbons-design-system';

import { SectionContainer } from '../../molecules/SectionContainer/SectionContainer';
import * as styles from './SectionTitleSection.style';

export type SectionTitleSectionProps = SectionTitleProps;

export const SectionTitleSection = ({ title }: SectionTitleSectionProps) => {
  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
      <SectionTitle title={title} />
    </SectionContainer>
  );
};

export type { SectionTitleProps };
